export default __webpack_public_path__ + "static/media/logo.f49d2c13.png";